import {RequestedDeviceItemModel} from './requested-device-item.model';
import {RequestedNotDeviceItemModel} from './requested-not-device-item.model';
import {DateTimeUtils} from '../utils/date-time.utils';

export class RequestedProductInfoModel {
    productDistributorId: number;
    secondaryProductDistributorId: number;
    rolloutStart: Date;
    rolloutEnd: Date;
    isOneshot = false;
    requestedProducts: (RequestedDeviceItemModel | RequestedNotDeviceItemModel) [] ;  // can contains device, warranty and accessory
    requestedServiceComment?: string;


    public static fromJson(requestedProductInfoModel: any): RequestedProductInfoModel {
        if ( requestedProductInfoModel ) {
            requestedProductInfoModel.rolloutStart = DateTimeUtils.StringToDate( requestedProductInfoModel.rolloutStart);
            requestedProductInfoModel.rolloutEnd = DateTimeUtils.StringToDate( requestedProductInfoModel.rolloutEnd);
            return requestedProductInfoModel as RequestedProductInfoModel;
        }
        return requestedProductInfoModel;
    }

    public static toJson(requestedProductInfo: RequestedProductInfoModel): object {
        const newRequestedProductInfo: object = {...requestedProductInfo};
        newRequestedProductInfo['rolloutStart'] = DateTimeUtils.DateToRestString(requestedProductInfo.rolloutStart);
        newRequestedProductInfo['rolloutEnd'] = DateTimeUtils.DateToRestString(requestedProductInfo.rolloutEnd);
        return newRequestedProductInfo;
    }

    // public static getNewInstance(){
    //     const result = new RequestedProductInfoModel();
    //     result.requestedProducts = [];
    //     return
    // }
}
